import { useMemo } from 'react';
import { OnsiteTemplateThumbnail } from '../../OnsiteTemplateThumbnail';
import { useSendEmail } from './hooks/useSendEmail';

export const SendEmailThumbnail = ({ id }) => {
  const { getTemplate } = useSendEmail();

  const template = useMemo(() => getTemplate(id), [getTemplate, id]);
  const templateId = useMemo(() => template?.id, [template?.id]);
  const supportedLanguage = useMemo(() => template?.supportedLanguage, [template?.supportedLanguage]);

  return <OnsiteTemplateThumbnail templateId={templateId} supportedLanguage={supportedLanguage} channel="offsite" />;
};
